import { getDefaultShopConfig } from './default';
import * as custom from '../filters/marketplace-custom-config';
import { getBrandDirectFilterConfig } from '../filters/brandDirect';
import { getSizeFilterConfig } from '../filters/size';
import { getConditionsFilterConfig } from '../filters/condition';

const mansurgavrielSizes: string[] = [
  'S',
  'M',
  'L',
  'IT 35',
  'IT 35.5',
  'IT 36',
  'IT 36.5',
  'IT 37',
  'IT 37.5',
  'IT 38',
  'IT 38.5',
  'IT 39',
  'IT 39.5',
  'IT 40',
  'IT 40.5',
  'IT 41',
  'IT 41.5',
  'IT 42',
  'IT 42.5',
  'IT 43',
  'IT 44',
  'IT 45',
  'IT 46',
];

export const mansurgavrielShopConfig = {
  ...getDefaultShopConfig(),
  filters: [
    ...custom.filters,
    getConditionsFilterConfig(),
    getBrandDirectFilterConfig(),
    getSizeFilterConfig({
      sizes: mansurgavrielSizes,
    }),
  ],
};
